(function () {
  'use strict';

  var timeline = document.getElementById('SectionTimeline');
  if (!timeline) return;

  var sectionSelectors = [
    { sel: '.agency-hero', label: 'Hero' },
    { sel: '.agency-services', label: 'Services' },
    { sel: '.agency-products', label: 'Products' },
    { sel: '.agency-process', label: 'Process' },
    { sel: '.agency-portfolio', label: 'Portfolio' },
    { sel: '.agency-testimonials', label: 'Reviews' },
    { sel: '.agency-resources', label: 'Blog' },
    { sel: '.agency-cta', label: 'Contact' }
  ];

  var sections = [];
  var cells = [];

  /* Build battery structure */
  var cap = document.createElement('div');
  cap.className = 'section-timeline__battery-cap';
  timeline.appendChild(cap);

  var battery = document.createElement('div');
  battery.className = 'section-timeline__battery';
  timeline.appendChild(battery);

  sectionSelectors.forEach(function (item) {
    var el = document.querySelector(item.sel);
    if (el) {
      sections.push(el);

      var cell = document.createElement('div');
      cell.className = 'section-timeline__cell';

      var label = document.createElement('span');
      label.className = 'section-timeline__label';
      label.textContent = item.label;
      cell.appendChild(label);

      cell.addEventListener('click', function () {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      battery.appendChild(cell);
      cells.push(cell);
    }
  });

  /* Percentage label below battery */
  var percent = document.createElement('div');
  percent.className = 'section-timeline__percent';
  percent.textContent = '0%';
  timeline.appendChild(percent);

  if (sections.length < 2) {
    timeline.style.display = 'none';
    return;
  }

  function updateTimeline() {
    var scrollTop = window.scrollY || window.pageYOffset;
    var windowHeight = window.innerHeight;
    var viewMid = scrollTop + windowHeight * 0.4;

    /* Find active section */
    var activeIndex = 0;
    for (var i = sections.length - 1; i >= 0; i--) {
      var rect = sections[i].getBoundingClientRect();
      var sectionTop = rect.top + scrollTop;
      if (viewMid >= sectionTop) {
        activeIndex = i;
        break;
      }
    }

    /* Update cells */
    cells.forEach(function (cell, i) {
      cell.classList.remove('is-active', 'is-filled');
      if (i === activeIndex) {
        cell.classList.add('is-active');
      } else if (i < activeIndex) {
        cell.classList.add('is-filled');
      }
    });

    /* Update percentage */
    var pct = Math.round((activeIndex / (sections.length - 1)) * 100);
    percent.textContent = pct + '%';

    /* Charging state when past first section */
    if (activeIndex > 0) {
      battery.classList.add('is-charging');
    } else {
      battery.classList.remove('is-charging');
    }
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        updateTimeline();
        ticking = false;
      });
      ticking = true;
    }
  });

  updateTimeline();
})();
